<div id="{{position}}" class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div *ngIf="!loading">
    <div class="feature-light-bg reveal-side-navigation"
      [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <!-- Pricing Table Default -->
      <div class="section-block">
        <div class="app-header-headline mb-80" [attr.data-aos]="textAnimation ? textAnimation : null">
          <h1 *ngIf="title" class="hero-title" [ngClass]="[titleSize]"
            [ngStyle]="{ 'color': titleColor?titleColor:textColor,'font-weight':fontWeight }"> {{
            title }}
          </h1>
          <p *ngIf="subTitle" class="sub-title center mb-10" [ngStyle]="{ 'color': textColor }">{{subTitle}}</p>
          <div *ngIf="hideSwitcher === false" [ngClass]="!pricingOption?'monthly-yearly':'monthly-yearly-disabled'">
            {{plans.length>0 && plans[0].monthlyText ? plans[0].monthlyText : 'Monthly'}} <mat-slide-toggle
              [(ngModel)]="pricingOption" [ngClass]="!pricingOption?'monthly-yearly-disabled':'monthly-yearly'">
              {{plans.length>0 && plans[0].yearlyText ? plans[0].yearlyText : 'Yearly'}}</mat-slide-toggle>
          </div>
        </div>

        <div class="pricing-container" [attr.data-aos]="itemsAnimation ? itemsAnimation : null">
          <div fxLayout="row wrap" fxLayout.xs="column">
            <div fxFlex *ngFor="let plan of plans; let planIndex = index" [ngClass]="editPlansClass"
              class="center-block">
              <div class="pricing-table-column bkg-white" [ngClass]="{'main-column': plan.mainOffre}">
                <div class="pricing-table-header bkg-grey-light color-charcoal">
                  <h2 class="weight-bold"> {{ plan.planName }} </h2>
                  <h3 *ngIf="plan.costYearly">
                    <ng-container *ngIf="plan.currency === '$' || plan.currency === 'USD'">
                      <span class="currency">$</span>
                    </ng-container>
                    <ng-container *ngIf="plan.currency && plan.currency !== '$' && plan.currency !== 'USD'">
                      <span class="currency"> {{plan.currency}} </span>
                    </ng-container>
                    <span *ngIf="!plan.promotionalPricing">{{ !pricingOption?plan.costMonthly:(monthPricePerYear?plan.costYearly/12:plan.costYearly) | number : '1.2-2' }}</span>
                    <span *ngIf="plan.promotionalPricing">{{ !pricingOption?plan.promotionalCostMonthly:(monthPricePerYear?plan.promotionalCostYearly/12:plan.promotionalCostYearly) | number : '1.2-2' }}</span>
                    <sup *ngIf="plan.promotionalPricing" [ngStyle]="{ 'color': plan.mainOffre?'#fff':''}">
                      {{ !pricingOption?plan.costMonthly:(monthPricePerYear?plan.costYearly/12:plan.costYearly) | number : '1.2-2' }}
                      <ng-container *ngIf="plan.currency && plan.currency !== '$' && plan.currency !== 'USD'">  {{plan.currency}} </ng-container>
                      <ng-container *ngIf="plan.currency === '$' || plan.currency === 'USD'"> $ </ng-container>
                    </sup>
                    <ng-container *ngIf="plan.periodicity && plan.periodicity !== ''">
                      <span class="interval">{{ plan.periodicity }} </span>
                    </ng-container>
                  </h3>
                  <ng-container *ngIf="plan.promotionalPricing">
                    <div>
                      <span class="discount" [ngStyle]="{ 'color': plan.mainOffre?'#fff':''}">{{getDiscountValue( !pricingOption?plan.promotionalCostMonthly:(monthPricePerYear?plan.promotionalCostYearly/12:plan.promotionalCostYearly),!pricingOption?plan.costMonthly:(monthPricePerYear?plan.costYearly/12:plan.costYearly)) | number : '1.0-0'}}% Discount</span>
                    </div>
                  </ng-container>
                  <div class="typePricing" [ngClass]="{'main-column-type': plan.mainOffre}">{{ pricingOption?
                    monthPricePerYear?( plans.length>0 && plans[0].monthlyText ? '/'+plans[0].monthlyText : '/Monthly'
                    ):( plans.length>0 && plans[0].yearlyText ? '/'+plans[0].yearlyText : '/Yearly' ):( plans.length>0
                    && plans[0].monthlyText ? '/'+plans[0].monthlyText : '/Monthly' ) }}</div>
                  <div *ngIf="plan.buttonText && plan.buttonLink">
                    <a [href]="plan.buttonLink | safeUrl" target="_blank" rel="noopener">
                      <button (click)="planClicked(plan)" [attr.aria-label]="plan.buttonText" mat-raised-button
                        color="primary" tabindex="0" aria-disabled="false">{{ plan.buttonText }}
                      </button>
                    </a>
                  </div>
                </div>
                <div class="pricing-table-options color-grey">
                  <!--<ng-container *ngFor="let feature of features; let i = index">
                      <span [ngClass]="{'pricing-unavailable-feature': !(feature | findIn: plan.availableFeatures)}"><i class="material-icons">check</i>  {{feature}} {{ feature | findIn: plan.availableFeatures }}</span> <br>
                  </ng-container> -->
                  <ng-container *ngFor="let feature of availableFeatures[planIndex]">
                    <i class="material-icons">check</i>
                    {{feature}}
                    <br>
                  </ng-container>
                  <ng-container *ngFor="let feature of customAvailableFeatures[planIndex]">
                    <i class="material-icons">check</i>
                    {{feature}}
                    <br>
                  </ng-container>
                  <ng-container *ngFor="let feature of unavailableFeatures[planIndex]">
                    <del><i class="material-icons">check</i>
                      {{feature}} </del>
                    <br>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Pricing Table Default End -->
    </div>
  </div>
</div>